import * as types from './constants';

export const sendPrompt = (payload, sendPromptApi) => {
  return {
    type: types.SEND_PROMPT_REQUEST,
    payload: { ...payload, status: 'PROMPT' },
    sendPromptApi,
  };
};
export const modifySQL = (payload, modifySQLApi, callback) => ({
  type: types.MODIFY_SQL_REQUEST,
  modifySQLApi,
  payload: { ...payload, status: 'PROMPT' },
  callback,
});


export const getSuggestion = (payload, callback, getSuggestionApi) => {
  return {
    type: types.GET_SUGGESTION_REQUEST,
    payload: { ...payload },
    callback,
    getSuggestionApi,
  };
};

export const fetchData = (payload, fetchDataApi) => ({
  type: types.FETCH_DATA_REQUEST,
  payload,
  fetchDataApi,
});

export const upvoteQuery = (
  prompt,
  query,
  callback,
  feedback,
  upvoteQueryApi,
) => ({
  type: types.UPVOTE_QUERY_REQUEST,
  upvoteQueryApi,
  prompt,
  query,
  callback,
  feedback,
});

export const setFetchStatus = id => ({
  type: types.SET_FETCH_STATUS,
  id,
});
export const cancelPrompt = payload => ({
  type: types.CANCEL_PROMPT,
  payload: { ...payload, status: 'CANCEL' },
});

export const sendLog = (payload, callback, sendLogApi) => ({
  type: types.SEND_LOG_REQUEST,
  sendLogApi,
  payload,
  callback,
});

export const resetGenie = () => ({
  type: types.RESET_GENIE,
});
